/** Basket/checkout footers: Products = SKU rows, Units = summed quantity. */

export const countBasketLinesAndUnits = (orders = []) => {
  const list = Array.isArray(orders) ? orders : []
  const lines = list.length
  const units = list.reduce(
    (sum, item) => sum + (Number(item?.quantity) || 0),
    0,
  )
  return { lines, units }
}

export const countCheckoutLinesAndUnits = (
  suppliers = [],
  selectedSupplierIds,
) => {
  const list = Array.isArray(suppliers) ? suppliers : []
  const selected =
    selectedSupplierIds && typeof selectedSupplierIds.has === 'function'
      ? list.filter(supplier => selectedSupplierIds.has(supplier?.supplierId))
      : list
  const items = selected.flatMap(supplier =>
    Array.isArray(supplier?.items) ? supplier.items : [],
  )
  return countBasketLinesAndUnits(items)
}
